import { render, staticRenderFns } from "./LayoutContentVerticalNav.vue?vue&type=template&id=033f9017&scoped=true"
import script from "./LayoutContentVerticalNav.vue?vue&type=script&lang=js"
export * from "./LayoutContentVerticalNav.vue?vue&type=script&lang=js"
import style0 from "./LayoutContentVerticalNav.vue?vue&type=style&index=0&id=033f9017&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033f9017",
  null
  
)

export default component.exports